import { BasicDialogProperties } from "../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2FeedbackDialogProperties extends BasicDialogProperties {
    constructor() {
        super();
    }
}
